import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RemindersKeys } from "web_myplann/Api/Reminders/RemindersKeys";
import { addReminderToListCache } from "web_myplann/Api/Reminders/remindersCacheUtils";
import {
	postClientIdentificationDocumentsIdRemindersV2,
	ReminderEntityTypeEnum,
	type ReminderResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";
import { getReminderEntityConfig } from "web_myplann/Reminders/Config/reminderEntityConfig";
import type { ReminderFormModel } from "web_myplann/Reminders/Forms/reminderFormSchema";
import { mapReminderFormToCreateRequest } from "web_myplann/Reminders/Mappers/mapReminderToRequest";

type CreateReminderVariables = {
	documentId: number;
	model: ReminderFormModel;
};

export const useIdentificationDocumentReminderCreateMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<ReminderResponseDTO, Error, CreateReminderVariables>({
		mutationFn: processResponse(
			({ documentId, model }: CreateReminderVariables) =>
				postClientIdentificationDocumentsIdRemindersV2(
					mapReminderFormToCreateRequest(
						model,
						getReminderEntityConfig(
							ReminderEntityTypeEnum.IdentificationDocument,
						),
					),
					documentId,
				),
		),
		onSuccess: (reminder, { documentId }) => {
			addReminderToListCache(
				queryClient,
				RemindersKeys.identificationDocumentList(documentId),
				reminder,
			);
		},
	});
};
